import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// slices

import chatReducer from './slices/chat';

import userReducer from './slices/user';
import authReducer from './slices/auth';
import zaloReducer from './slices/zalo';
import facebookReducer from './slices/facebook';
import conversationZaloReducer from './slices/conversationZalo';
import conversationFacebookReducer from './slices/conversationFacebook';
import contactReducer from './slices/contact';
import ioReducer from './slices/io';
import roleReducer from './slices/role';
import queueReducer from './slices/queue';
import ticketReducer from './slices/ticket';
import janusReducer from './slices/janus';
import notificationReducer from './slices/notification';
import accessReducer from './slices/access';
import postFacebookReducer from './slices/postFacebook';
import selectedReducer from './slices/selected';
import janusVideoReducer from './slices/janusVideo';
import conversationLiveReducer from './slices/conversationLive';
import widgetReducer from './slices/widget';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};
const authPersistConfig = {
  key: 'auth',
  storage,
  keyPrefix: 'key-',
};
const rootReducer = combineReducers({
  // phone: phoneReducer,
  chat: chatReducer,
  //blog: blogReducer,
  contact: contactReducer,
  user: userReducer,
  authReducer: persistReducer(authPersistConfig, authReducer),
  zalo: zaloReducer,
  facebook: facebookReducer,
  ioReducer: ioReducer,
  conversationZalo: conversationZaloReducer,
  conversationFacebook: conversationFacebookReducer,
  role: roleReducer,
  notification: notificationReducer,
  queue: queueReducer,
  ticket: ticketReducer,
  janus: janusReducer,
  access: accessReducer,
  selected: selectedReducer,
  io: ioReducer,
  postFacebook: postFacebookReducer,
  conversationLive:conversationLiveReducer,
  janusVideo:janusVideoReducer,
  widget:widgetReducer

  // calendar: calendarReducer,
  // kanban: kanbanReducer,
  // product: persistReducer(productPersistConfig, productReducer)
});

export { rootPersistConfig, rootReducer };
